import React, { Component } from 'react'
import { connect } from 'react-redux'
import { func, bool, string } from 'prop-types'
import { sceneItemsType, compositionDataItemsType } from 'models/propTypes'

import { visit } from 'utils/tracker'
import { openScene, fetchScenes } from 'models/scenes/actions'
import { openComposition, deleteComposition, requestCompositions } from 'models/compositions/actions'
import { closeWelcomePopup, viewStockScenes } from 'models/ui/actions'
import { requestEarlyAccessSubscription } from 'models/user/actions'

import Dashboard from 'components/dashboard/Dashboard'

import { getUserSceneItems, getIsFetching, getStockSceneItems } from 'models/scenes/selectors'
import { getUserCompositionsData, getNonHiddenStockCompositionsData } from 'models/compositions/selectors'
import { getShouldShowWelcomePopup } from 'models/ui/selectors'
import { getIsLoggedIn, getEarlyAccessSubscribeStatus, getUserEmail } from 'models/user/selectors'

class DashboardContainer extends Component {
    constructor(props) {
        super(props)
        this.onSceneOpen = this.onSceneOpen.bind(this)
        this.onCompositionOpen = this.onCompositionOpen.bind(this)
        this.onCompositionDelete = this.onCompositionDelete.bind(this)
        this.onEarlyAccess = this.onEarlyAccess.bind(this)
    }

    componentDidMount() {
        visit('Dashboard')
        this.props.fetchScenes()
        this.props.requestCompositions()
    }

    onSceneOpen(id) {
        this.props.openScene(id)
    }

    onCompositionOpen(id) {
        this.props.openComposition(id)
    }

    onCompositionDelete(id) {
        this.props.deleteComposition(id)
    }

    onEarlyAccess() {
        this.props.signUp(this.props.userEmail)
    }

    render() {
        const {
            sceneItems,
            stockSceneItems,
            compositionDataItems,
            stockCompositionDataItems,
            shouldShowWelcomePopup,
            scenesLoading,
            isLoggedIn,
            earlyAccessStatus,
            userEmail,
        } = this.props

        return (
            <Dashboard
                sceneItems={sceneItems}
                stockSceneItems={stockSceneItems}
                compositionDataItems={compositionDataItems}
                stockCompositionDataItems={stockCompositionDataItems}
                onSceneOpen={this.onSceneOpen}
                onCompositionOpen={this.onCompositionOpen}
                onCompositionDelete={this.onCompositionDelete}
                shouldShowWelcomePopup={shouldShowWelcomePopup}
                closeWelcomePopup={this.props.closeWelcomePopup}
                scenesLoading={scenesLoading}
                viewStockScenes={this.props.viewStockScenes}
                isLoggedIn={isLoggedIn}
                earlyAccessStatus={earlyAccessStatus}
                onEarlyAccess={this.onEarlyAccess}
                hasEmail={!!userEmail}
            />
        )
    }
}

DashboardContainer.defaultProps = {
    userEmail: null,
}

DashboardContainer.propTypes = {
    sceneItems: sceneItemsType.isRequired,
    stockSceneItems: sceneItemsType.isRequired,
    compositionDataItems: compositionDataItemsType.isRequired,
    stockCompositionDataItems: compositionDataItemsType.isRequired,
    openScene: func.isRequired,
    openComposition: func.isRequired,
    deleteComposition: func.isRequired,
    shouldShowWelcomePopup: bool.isRequired,
    closeWelcomePopup: func.isRequired,
    scenesLoading: bool.isRequired,
    viewStockScenes: func.isRequired,
    isLoggedIn: bool.isRequired,
    earlyAccessStatus: string.isRequired,
    signUp: func.isRequired,
    userEmail: string,
    fetchScenes: func.isRequired,
    requestCompositions: func.isRequired,
}

const mapStateToProps = (state) => ({
    sceneItems: getUserSceneItems(state),
    stockSceneItems: getStockSceneItems(state),
    compositionDataItems: getUserCompositionsData(state),
    stockCompositionDataItems: getNonHiddenStockCompositionsData(state),
    shouldShowWelcomePopup: getShouldShowWelcomePopup(state),
    scenesLoading: getIsFetching(state),
    isLoggedIn: getIsLoggedIn(state),
    earlyAccessStatus: getEarlyAccessSubscribeStatus(state),
    userEmail: getUserEmail(state),
})

const mapDispatchToProps = (dispatch) => ({
    openScene: (id) => dispatch(openScene(id)),
    openComposition: (id) => dispatch(openComposition(id)),
    deleteComposition: (id) => dispatch(deleteComposition(id)),
    closeWelcomePopup: () => dispatch(closeWelcomePopup()),
    viewStockScenes: () => dispatch(viewStockScenes()),
    signUp: (email) => dispatch(requestEarlyAccessSubscription(email)),
    fetchScenes: () => dispatch(fetchScenes()),
    requestCompositions: () => dispatch(requestCompositions()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer)
